<template>
    <transition name="modal">
        <div class="modal-mask" v-bind="$attrs">
            <div class="modal-wrapper">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header bg-maroon text-white">
                            <h5 class="modal-title">
                                <slot name="header"></slot>
                            </h5>
                            <button @click="onClose" aria-label="Close" class="close text-white" type="button">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <slot default></slot>
                        </div>
                        <div class="modal-footer" v-if="hasFooterSlot">
                            <slot name="footer"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
    export default {
        computed: {
            hasFooterSlot() {
                return !!this.$slots['footer']
            }
        },
        methods: {
            onClose() {
                this.$emit('close')
            }
        }
    }
</script>

<style scoped>
    .modal-header{

    }
</style>
